module.exports = __webpack_public_path__ + "static/built-to-last-b1c4778945a271a2545c1c9aac4f6966.jpg";